export default __webpack_public_path__ + "13933033991f62d6bb641c7a19c8c431.ttf";